import { DataResponse } from '../src/dataResponse';
import { FileResponse } from '../src/fileResponse';
import { LoginResponse } from '../src/loginResponse';

export {
  DataResponse,
  FileResponse,
  LoginResponse
};
